import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { KeycloakService } from 'keycloak-angular';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import merge from 'lodash.merge';
import mergewith from 'lodash.mergewith';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  constructor(private httpClient: HttpClient, private translate: TranslateService, private keycloakService: KeycloakService, @Inject(DOCUMENT) private document: Document) { }

  fetchConfiguration() {
    return this.httpClient.get<any>(`./assets/config/config.json?cacheBuster=${new Date().getTime()}`);
  }

  /**
   * Fetch config + override current config (environment variable) with remote value.
   * @returns
   */
  refreshConfiguration(): Observable<any> {
    function overrideArray(objValue: any, srcValue: any) {
      if (objValue && Array.isArray(objValue)) {
        return srcValue;
      }
    }

    return this.fetchConfiguration().pipe(tap(config => {
      merge(environment.production, config.production);
      mergewith(environment.application, config.application);
      mergewith(environment.defaultValue, config.defaultValue, overrideArray);
      mergewith(environment.airweb, config.airweb, overrideArray);
      mergewith(environment.api, config.api, overrideArray);
      mergewith(environment.kibana, config.kibana, overrideArray);
      mergewith(environment.keycloak, config.keycloak, overrideArray);
      mergewith(environment.access, config.access, overrideArray);
      mergewith(environment.user, config.user, overrideArray);
      mergewith(environment.userAccountPhoto, config.userAccountPhoto, overrideArray);
      mergewith(environment.maasProduct, config.maasProduct, overrideArray);
      mergewith(environment.opp, config.opp);
      mergewith(environment.maintenance, config.maintenance, overrideArray);

      if (config.roles) {
        environment.roles = [...new Set<string>(config.roles)];
      }
    }));
  }

  /**
   * Add custom translations
   */
  async addCustomTranslation(): Promise<any> {
    await this.reloadTranslation();
  }

  /**
   * Reload translations
   */
  async reloadTranslation(): Promise<any> {
    this.translate.reloadLang('fr').subscribe(() => {
      this.httpClient.get(`./assets/i18n/custom/fr.json?cacheBuster=${new Date().getTime()}`).subscribe((translations: any) => {
        this.translate.setTranslation('fr', translations, true)
      });
    });
  }
}
